import React, { useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import Swal from "sweetalert2";
import axiosInstance from "../../Shared/axiosInstance";
import CustomDatePicker from "../CustomDate/CustomDatePicker";

export default function أفضل_العملاء() {
  const [customers, setCustomers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [loading, setLoading] = useState(true);

  // Filters
  const [sortBy, setSortBy] = useState("amount");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [top, setTop] = useState(5);

  const fetchTopCustomers = async () => {
    setLoading(true);
    try {
      const params = { sortBy, top };
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const { data } = await axiosInstance.get("/Analysis/top-customers", { params });

      setCustomers(data?.data || []);
      setSummary(data?.summary || null);
      setDateFilter(data?.dateFilter || null);
    } catch (error) {
      console.error("خطأ أثناء جلب أفضل العملاء:", error);
      Swal.fire("خطأ", "فشل تحميل أفضل العملاء", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopCustomers();
  }, [sortBy, startDate, endDate, top]);

  if (loading) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جارٍ تحميل أفضل العملاء...
        </p>
      </div>
    );
  }

  return (
    <div className="container py-5" style={{ maxWidth: "1400px", direction: "rtl" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
        <div>
          <h2 style={{ color: "#2563eb", fontWeight: "700", fontSize: "28px", marginBottom: "4px" }}>
            تحليل أفضل العملاء
          </h2>
          <small style={{ color: "#64748b", fontSize: "14px" }}>
            عرض أفضل {customers.length} عملاء حسب {sortBy === "amount" ? "إجمالي المبلغ" : "عدد المبيعات"}
          </small>
        </div>
      </div>

      {/* Filters Section */}
      <div
        className="mb-4"
        style={{
          background: "#fff",
          border: "1px solid #dbeafe",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
        }}
      >
        <h5 style={{ color: "#1e40af", fontWeight: "600", fontSize: "16px", marginBottom: "16px" }}>
          خيارات التصفية
        </h5>
        <div className="row g-3">
          <div className="col-md-3">
            <label style={{ color: "#475569", fontSize: "14px", fontWeight: "600", marginBottom: "6px" }}>
              ترتيب حسب
            </label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              style={selectStyle}
            >
              <option value="amount">إجمالي المبلغ</option>
              <option value="count">عدد المبيعات</option>
            </select>
          </div>

          <div className="col-md-3">
            <label style={{ color: "#475569", fontSize: "14px", fontWeight: "600", marginBottom: "6px" }}>
              أفضل العملاء
            </label>
            <select value={top} onChange={(e) => setTop(Number(e.target.value))} style={selectStyle}>
              <option value="3">أفضل 3</option>
              <option value="5">أفضل 5</option>
              <option value="10">أفضل 10</option>
              <option value="20">أفضل 20</option>
            </select>
          </div>

<div className="col-md-3">
            <CustomDatePicker
              label="من تاريخ"
              value={startDate}
              onChange={setStartDate}
              placeholder="اختر تاريخ البداية"
              maxDate={endDate ? new Date(endDate) : null}
            />
          </div>

          <div className="col-md-3">
            <CustomDatePicker
              label="إلى تاريخ"
              value={endDate}
              onChange={setEndDate}
              placeholder="اختر تاريخ النهاية"
              minDate={startDate ? new Date(startDate) : null}
            />
          </div>



        </div>
      </div>

      {/* Date Filter Info */}
      {dateFilter && (
        <div style={dateFilterStyle}>
          <i className="bi bi-calendar-range me-2"></i>
          النطاق الزمني: {dateFilter.description}
        </div>
      )}

      {/* Table */}
      {customers.length > 0 ? (
        <div className="table-responsive mt-5">
          <table className="table mb-0" style={tableStyle}>
            <thead style={{ background: "#dbeafe" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>اسم العميل</th>
                <th style={thStyle}>الهاتف</th>
                <th style={thStyle}>إجمالي المبلغ</th>
                <th style={thStyle}>إجمالي المدفوع</th>
                <th style={thStyle}>المتبقي</th>
                <th style={thStyle}>عدد المبيعات</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c, index) => (
                <tr key={c.id} style={{ background: index % 2 === 0 ? "#f8fafc" : "#ffffff" }}>
                  <td style={tdStyle}>
                    <span style={badgeStyle("#dbeafe", "#1e40af")}>{index + 1}</span>
                  </td>
                  <td style={{ ...tdStyle, fontWeight: 700, color: "#2563eb" }}>{c.name}</td>
                  <td style={tdStyle}>{c.phone}</td>
                  <td style={tdStyle}>
                    <span style={badgeStyle("#bbf7d0", "#14532d")}>{c.totalAmount.toFixed(2)} EGP</span>
                  </td>
                  <td style={{ ...tdStyle, color: "#2563eb" }}>{c.totalPaid.toFixed(2)} EGP</td>
                  <td style={{ ...tdStyle, color: c.totalRemaining > 0 ? "#dc2626" : "#64748b", fontWeight: 700 }}>
                    {c.totalRemaining.toFixed(2)} EGP
                  </td>
                  <td style={tdStyle}>
                    <span style={badgeStyle("#dbeafe", "#1e40af", "20px")}>{c.salesCount}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={noDataStyle}>
          <i className="bi bi-person-lines-fill" style={{ fontSize: "64px", color: "#94a3b8", marginBottom: "20px" }}></i>
          <h4 style={{ color: "#475569", fontWeight: "600", marginBottom: "8px" }}>لا يوجد عملاء</h4>
          <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>جرب تعديل خيارات التصفية لعرض النتائج</p>
        </div>
      )}
    </div>
  );
}

// Styles
const selectStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #bfdbfe",
  borderRadius: "6px",
  fontSize: "15px",
  color: "#475569",
  outline: "none",
  cursor: "pointer",
  background: "#fff",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #bfdbfe",
  borderRadius: "6px",
  fontSize: "15px",
  color: "#475569",
  outline: "none",
  transition: "all 0.2s",
};

const dateFilterStyle = {
  background: "#dbeafe",
  border: "1px solid #93c5fd",
  borderRadius: "6px",
  padding: "12px 16px",
  color: "#1e40af",
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "12px",
};

const tableStyle = {
  border: "1px solid #dbeafe",
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
  textAlign: "center",
};

const thStyle = { color: "#1e40af", fontSize: "18px", padding: "12px 8px", fontWeight: "600", border: "1px solid #bfdbfe" };
const tdStyle = { padding: "12px 8px", border: "1px solid #e0e7ff", fontSize: "18px", fontWeight: "600", color: "#475569" };

const badgeStyle = (bg, color, borderRadius = "6px") => ({
  background: bg,
  color: color,
  padding: "6px 12px",
  borderRadius: borderRadius,
  fontSize: "14px",
  fontWeight: "700",
});

const noDataStyle = {
  background: "#fff",
  border: "1px solid #dbeafe",
  borderRadius: "8px",
  padding: "60px 20px",
  textAlign: "center",
  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
};
